import Vue from 'vue'
import '@/plugins/firebase'
import firebase from 'firebase/app'
import '@/plugins/axios'
import i18n from '@/plugins/i18n'
import '@/plugins/fontawesome'
import App from '@/App.vue'
// import '@/registerServiceWorker'
import router from '@/router'
import store from '@/store'
import '@/plugins/dayjs'
import '@/plugins/element'
import '@/plugins/videojs'
import '@/plugins/filter'
import vuetify from '@/plugins/vuetify'
import '@/plugins/aos'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(VueMeta, {
  tagIDKeyName: 'vmid',
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})
let app

firebase.auth().onAuthStateChanged(async (user) => {
  // TODO: 파라미터 체크하여 localStorage에 저장
  // 서비스 정보 가져오기
  if (!store.getters.statusList) await store.dispatch('getServiceInfo')

  // 점검 중 상태 체크
  if (
    store.getters.statusList !== null &&
    store.getters.statusList !== undefined &&
    store.getters.statusList.isMaintainance
  )
    router.push({ name: 'Maintenance' })
  // 점검 중이 아닐 때 정상 수행
  // else if (!location.pathname.includes('public')) {
  else {
    // URL에 전달된 쿼리 체크
    let params = new URLSearchParams(window.location.search)

    // 매직 링크일 경우
    if (params.get('passedWsId') !== null && params.get('magicLinkCode') !== null) {
      // 이메일 초대와 중복을 피하기 위해 이메일 초대 관련 내용 localStorage 체크하여 제거
      if (localStorage.getItem('passedEmail') !== null) localStorage.removeItem('passedEmail')
      if (localStorage.getItem('passedWsId') !== null) localStorage.removeItem('passedWsId')

      // 넘어온 파라미터 값 중 magicLinkCode와 wsId를 localStorage에 저장
      localStorage.setItem('passedWsId', params.get('passedWsId'))
      localStorage.setItem('magicLinkCode', params.get('magicLinkCode').replaceAll(' ', '+'))
    }

    // 로그인 아닐 때
    if (!user) {
      // if (location.pathname.includes('public')) {
      //   localStorage.setItem('publicLink', window.location.pathname)
      // } else {
      // 이메일 등으로 접속했을 경우
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        // 매직 코드와 중복을 피하기 위해 매직 코드 관련 내용 localStorage 체크하여 제거
        if (localStorage.getItem('passedWsId') !== null) localStorage.removeItem('passedWsId')
        if (localStorage.getItem('magicLinkCode') !== null) localStorage.removeItem('magicLinkCode')

        // 넘어온 파라미터 값 중 email과 wsId를 localStorage에 저장
        // action code가 invalid여도, 가입 후 워크스페이스 참여될 수 있도록 처리
        localStorage.setItem('passedEmail', params.get('passedEmail'))
        localStorage.setItem('passedWsId', params.get('passedWsId'))

        // 원래 firebase에서 지원하는 email link로 가입은 사용하지 않음
        // try {
        //   firebase
        //     .auth()
        //     .signInWithEmailLink(params.get('passedEmail'), window.location.href)
        //     .then(async (result) => {
        //       // 초대를 통한 가입일 경우 firebase user 정보의 display name을 email의 계정명으로 지정
        //       if (result.additionalUserInfo.isNewUser) {
        //         await firebase.auth().currentUser.updateProfile({
        //           userDisplayName: firebase.auth().currentUser.email.split(',').shift(),
        //         })
        //         console.log(firebase.auth().currentUser)
        //       }
        //     })
        // } catch (error) {
        //   console.log(error.code, error.message)
        //   // TODO: 번역
        //   alert(error.message)
        // }
      }
      // }

      // 로그인 상태가 아닌데 타이머가 살아있으면 제거
      if (Vue.config.tokenTimer !== undefined || Vue.config.tokenTimer !== null) {
        clearInterval(Vue.config.tokenTimer)
        Vue.config.tokenTimer = null
      }
    } else {
      // 로그인 상태일 경우, 30분마다 토큰/회원/API헤더 갱신
      if (Vue.config.tokenTimer === undefined || Vue.config.tokenTimer === null)
        Vue.config.tokenTimer = setInterval(async () => {
          let user
          try {
            user = firebase.auth().currentUser
            if (user) await user.getIdToken(true)
          } catch (error) {
            if (error && (error['code'] === 'auth/user-token-expired' || error['message'] === 'TOKEN_EXPIRED')) {
              // 1. 토큰이 만료되었을 경우 firebase admin sdk 를 사용하여 유저 토큰정보를 다시 받아온다.
              // 2. 그 이후 lambda 에서 받은 token 으로 재로그인
              try {
                await store.dispatch('getUserToken', user['uid'])
                let result = store.getters.userToken
                let userResult = await firebase.auth().signInWithCustomToken(result)
                user = userResult
              } catch (error) {
                console.log('sign in with token error  ', error)
              }
            }
          }
          await store.dispatch('setCurrentUser', user)
          await store.dispatch('setApiHeader')
        }, 1800000)
    }
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app')
  }
})
